var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0023 2.06419C12.9373 2.4564 15.3794 4.74247 15.9507 7.65608C16.354 9.71802 15.8275 11.6567 14.7409 13.1583L21.832 20.2406C22.056 20.4648 22.056 20.8121 21.832 21.0363L21.0366 21.8319C20.8126 22.056 20.4653 22.056 20.2412 21.8319L13.1502 14.7384C11.649 15.8254 9.71103 16.3409 7.64981 15.9375C4.7372 15.3771 2.45192 12.923 2.05984 9.98696C1.46612 5.35881 5.37573 1.44785 10.0023 2.06419ZM9.0501 13.8307C11.6938 13.8307 13.8447 11.6791 13.8447 9.03444C13.8447 6.38978 11.6938 4.23819 9.0501 4.23819C6.40635 4.23819 4.2555 6.38978 4.2555 9.03444C4.2555 11.6791 6.40635 13.8307 9.0501 13.8307Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.1d754491d65eeb08c148a5457f3fc4ef.svg";
export { ForwardRef as ReactComponent };